import {
  jb_navigation_tags_css_default
} from "./chunk.U6GXZBZD.js";
import {
  Spaceable
} from "./chunk.3FKBYJ4V.js";
import {
  to
} from "./chunk.BMHRULEY.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  respondTo
} from "./chunk.NKAUZW5M.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  e,
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-navigation-tags/jb-navigation-tags.ts
var JbNavigationTags = class extends Spaceable(r) {
  constructor() {
    super(...arguments);
    this.ARIALABELS_DEFAULT = {
      active: "Active"
    };
    this._showButton = false;
  }
  firstUpdated() {
    window.addEventListener("resize", () => {
      this._calculateShowButton();
    });
    setTimeout(() => {
      this._calculateShowButton();
    }, 0);
  }
  _calculateShowButton() {
    const element = this._list.firstElementChild;
    const styles = window.getComputedStyle(element);
    const heightWithMargin = element.offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
    const actualHeight = this._list.scrollHeight - 30;
    if (respondTo({ xs: "mobile", sm: "desktop" }) === "mobile") {
      if (actualHeight >= heightWithMargin * 4) {
        this._showButton = true;
      } else {
        this._showButton = false;
      }
    } else {
      if (actualHeight >= heightWithMargin * 2) {
        this._showButton = true;
      } else {
        this._showButton = false;
      }
    }
    this._setTabindexes();
  }
  _getContentSpacingProperties() {
    return { colsMdUp: 10, type: "navigation-tags" };
  }
  _renderItem(item, indx) {
    return ke`<li
      class="list-item animate-left-bottom ${item.tag === this.activeItem ? "active" : ""}"
      data-search-action-url=${to(item.searchAction)}
      data-search-suggest-url=${to(item.suggestUrl)}
      data-index="${indx}"
      @click=${(evt) => {
      this._setActive(evt.target);
    }}
      @keyup=${(evt) => {
      this._setActive(evt.target);
    }}
    >
      <a
        href=${to(item.link.href)}
        data-tag=${item.tag}
        @click=${this._trackClicks}
        >${item.tag}${item.tag === this.activeItem ? ke`<span class="sr-only"> (${this.ARIALABELS_DEFAULT.active})</span>` : D}</a
      >
    </li>`;
  }
  _setActive(elm) {
    const parentElement = elm.closest("ul");
    const currentActive = parentElement.querySelector(".active");
    if (currentActive) {
      currentActive.classList.remove("active");
      const srElement2 = currentActive.querySelector(".sr-only");
      srElement2.remove();
    }
    const currentLi = elm.closest("li");
    currentLi.classList.add("active");
    const srElement = document.createElement("span");
    srElement.classList.add("sr-only");
    srElement.innerHTML = ` (${this.ARIALABELS_DEFAULT.active})`;
    elm.appendChild(srElement);
  }
  _setTabindexes() {
    const listHeight = this._list.offsetHeight;
    const listTopPosition = this._list.offsetTop;
    this.renderRoot.querySelectorAll(".list-item").forEach((lmt) => {
      const itemLink = lmt.querySelector("a");
      itemLink.removeAttribute("tabindex");
      lmt.removeAttribute("aria-hidden");
      if (lmt.offsetTop - listTopPosition > listHeight) {
        lmt.setAttribute("aria-hidden", "");
        itemLink.setAttribute("tabindex", "-1");
      }
    });
  }
  _trackClicks(evt) {
    const eventTarget = evt.composedPath()[0];
    const tag = eventTarget.dataset.tag ?? evt.detail.label;
    const url = eventTarget.href ?? evt.detail.newValue;
    this.dispatchEvent(
      new CustomEvent("jb-navigation-tags:filter", {
        detail: {
          tag,
          url
        },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke`<nav
      role="navigation"
      aria-label="Tag navigation"
      class="navigation-tags ${this.type}"
      part="navigation"
    >
      <input
        type="checkbox"
        id="checkbox"
        @change=${() => {
      setTimeout(() => {
        this._setTabindexes();
      }, 300);
      this.requestUpdate();
    }}
      />
      ${this.heading ? ke`<jb-section-headline .headline=${this.heading}></jb-section-headline>` : D}
      <ul
        class="list"
        part="list"
      >
        ${this.items.map((item, indx) => this._renderItem(item, indx))}
      </ul>
      ${this._showButton ? ke` <div class="title-wrapper">
            <label
              for="checkbox"
              data-open="${this.toOpenText}"
              data-close="${this.toCloseText}"
              tabindex="0"
              @keydown=${(evt) => {
      if (evt.key === "Enter" || evt.key === " ") {
        this._input.checked = !this._input.checked;
        setTimeout(() => {
          this._setTabindexes();
        }, 300);
        this.requestUpdate();
      }
    }}
            >
              <jb-chevron-icon direction=${this._input?.checked ? "up" : "down"}></jb-chevron-icon>
            </label>
          </div>` : D}
    </nav>`;
  }
};
JbNavigationTags.styles = [reset_css_default, jb_navigation_tags_css_default];
__decorateClass([
  n()
], JbNavigationTags.prototype, "activeItem", 2);
__decorateClass([
  n({ type: Object })
], JbNavigationTags.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "heading", 2);
__decorateClass([
  n({ type: Array })
], JbNavigationTags.prototype, "items", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "toCloseText", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "toOpenText", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "type", 2);
__decorateClass([
  e("input")
], JbNavigationTags.prototype, "_input", 2);
__decorateClass([
  e(".list")
], JbNavigationTags.prototype, "_list", 2);
__decorateClass([
  r2()
], JbNavigationTags.prototype, "_showButton", 2);
JbNavigationTags = __decorateClass([
  customElement("jb-navigation-tags")
], JbNavigationTags);

export {
  JbNavigationTags
};
